import type { CSSProperties, ReactNode } from 'react';
import { Icon } from '../core/Icon';

export type AIState = 'sugerido' | 'pendente' | 'executando' | 'concluido' | 'falhou' | 'confirmar' | 'cancelado' | 'expirado';

const estados: Record<AIState, { icon: string; label: string; bg: string; fg: string }> = {
    sugerido: { icon: 'sparkles', label: 'Sugerido', bg: 'var(--surface-secondary)', fg: 'var(--neutral-700)' },
    pendente: { icon: 'clock', label: 'Pendente', bg: 'var(--warning-soft)', fg: 'var(--warning-strong)' },
    executando: { icon: 'loader', label: 'Executando', bg: 'var(--info-soft)', fg: 'var(--info-strong)' },
    concluido: { icon: 'circle-check', label: 'Concluído', bg: 'var(--success-soft)', fg: 'var(--success-strong)' },
    falhou: { icon: 'circle-alert', label: 'Falhou', bg: 'var(--danger-soft)', fg: 'var(--danger-strong)' },
    confirmar: { icon: 'shield-alert', label: 'Requer confirmação', bg: 'var(--surface-brand-soft)', fg: 'var(--text-brand)' },
    /* Fins sem execução (Brain, B4): quem cancelou e o prazo que venceu não são
       falha — cor neutra, e sem o "x" do AICard, porque não há o que dispensar. */
    cancelado: { icon: 'ban', label: 'Cancelada', bg: 'var(--surface-secondary)', fg: 'var(--neutral-700)' },
    expirado: { icon: 'timer-off', label: 'Expirada', bg: 'var(--surface-secondary)', fg: 'var(--neutral-700)' },
};

export interface AIStatePillProps {
    state?: AIState;
    /** Sobrescreve o rótulo do estado. */
    label?: ReactNode;
    style?: CSSProperties;
}

export function AIStatePill({ state = 'sugerido', label, style }: AIStatePillProps) {
    const s = estados[state] ?? estados.sugerido;
    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, height: 22, padding: '0 9px', borderRadius: 'var(--radius-pill)', background: s.bg, color: s.fg, fontFamily: 'var(--font-ui)', fontSize: 12, fontWeight: 600, ...style }}>
            <Icon name={s.icon} size={12} style={{ animation: state === 'executando' ? 'vec-spin 1.1s linear infinite' : 'none' }} />
            {label ?? s.label}
            <style>{'@keyframes vec-spin{to{transform:rotate(360deg)}}'}</style>
        </span>
    );
}
